import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import DeleteForeverTwoToneIcon from "@mui/icons-material/DeleteForeverTwoTone";

interface Props {
  open: boolean;
  onClose: () => void; // triggered when user click cancel
  onConfirm: () => void; // triggered when user click confirm to delete data
}

export default function DeleteConfirmationBox({
  open,
  onClose,
  onConfirm,
}: Props) {
  const handleConfirm = () => {
    onConfirm(); // Trigger the delete action
    onClose(); // Close the dialog
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <DeleteForeverTwoToneIcon color="error" />
          <Typography variant="h6">Confirm Delete</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Confirm Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
